import Grid from "@intility/bifrost-react/Grid";
import Icon from "@intility/bifrost-react/Icon";
import Message from "@intility/bifrost-react/Message";
import { Link, Navigate, useParams } from "react-router";
import { usePlatforms } from "~/api/platforms";

// Old /blueprints/:slug links and bookmarks. A blueprint now lives in the
// Blueprint tab of its platform page, so find the platform that has this
// slug and go there.
export default function BlueprintSlugRedirect() {
  const { slug } = useParams();
  const { data: platforms, isLoading, error } = usePlatforms();

  if (isLoading) {
    return (
      <div className="bf-content bf-page-padding">
        <Grid gap={16} style={{ minHeight: 100, placeContent: "center" }}>
          <Icon.Spinner size={24} />
        </Grid>
      </div>
    );
  }

  const platform = platforms?.find((p) => p.slug === slug);
  if (error || !platform) {
    return (
      <div className="bf-content bf-page-padding">
        <Message state="alert" header="Not found">
          {error instanceof Error ? (
            error.message
          ) : (
            <>
              No platform of yours has the blueprint <code>{slug}</code>. Find
              the platform in <Link to="/platforms">Platforms</Link>.
            </>
          )}
        </Message>
      </div>
    );
  }

  return <Navigate to={`/platforms/${platform.id}?tab=blueprint`} replace />;
}
